// Firebase Analytics is native-only (install tracking / attribution); the
// web build uses GTM + Snowplow instead.
export async function enableFirebaseAnalytics(): Promise<void> {
  console.log('[firebase][web] Analytics not used on web, skipping');
}

export async function disableFirebaseAnalytics(): Promise<void> {
  // no-op on web
}

export interface FirebasePurchaseParams {
  value: number;
  currency: string;
  productId: string;
  transactionId?: string;
}

export async function logFirebasePurchase(_params: FirebasePurchaseParams): Promise<void> {
  // no-op on web (purchases are tracked via GTM + Snowplow there)
}

export async function getFirebaseAppInstanceId(): Promise<string | null> {
  return null;
}
